import api from './baseApi'

export function getAllMunicipalities(){
    return api.get('municipalities/getAll')
}

export function inserimentoMassivoComuni(){
    return api.get(`municipalities/inserimentoMassivoComuni`);
  }
